import { PageType } from "~/lib/router/enums";

export const pathname = "/podcast";

export const page = {
  route(query: QueryParameters<{ entityId: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Podcast },
    };
  },
};
